import { RoutePaths } from '@/routes'
import { useState, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { ListRoutes } from '@/routes/routes'

export const AUTH_TOKEN_KEY = '@leiturinha-preference-center/token'

export function useAuth() {
  const [isAuthenticated, setIsAuthenticated] = useState(false)
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    const token = sessionStorage.getItem(AUTH_TOKEN_KEY)
    const currentRoute = ListRoutes().find(
      (route) => route.path === location.pathname
    )
    const isPrivateRoute = currentRoute?.isPrivate ?? false

    if (token) {
      try {
        const tokenData = JSON.parse(atob(token.split('.')[1]))
        const expirationTime = tokenData.exp * 1000 // Convertendo para milissegundos

        if (Date.now() >= expirationTime) {
          // Token expirado
          removeAuthToken()
          if (isPrivateRoute) {
            navigate(RoutePaths.login)
          }
        } else {
          setIsAuthenticated(true)
          if (window.location.pathname === RoutePaths.login) {
            navigate(RoutePaths.preferences)
          }
        }
      } catch {
        // Token inválido
        removeAuthToken()
        if (isPrivateRoute) {
          navigate(RoutePaths.login)
        }
      }
    } else {
      if (isPrivateRoute) {
        navigate(RoutePaths.login)
      }
    }
  }, [navigate, location.pathname])

  const setAuthToken = (token: string) => {
    sessionStorage.setItem(AUTH_TOKEN_KEY, token)
    setIsAuthenticated(true)
    navigate(RoutePaths.preferences)
  }

  const removeAuthToken = () => {
    sessionStorage.removeItem(AUTH_TOKEN_KEY)
    setIsAuthenticated(false)
  }

  return {
    isAuthenticated,
    setAuthToken,
    removeAuthToken
  }
}
